// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__FAOvY","navContainer":"Navbar_navContainer__LzCc2","logo":"Navbar_logo__HBzkQ","navMenu":"Navbar_navMenu__eYjgw","navLink":"Navbar_navLink__aYUe7"};